



























































































































import {Component} from "vue-property-decorator";
import {Getter} from "vuex-class";
import BaseItemsPage from "../BaseItemsPage";
import OverdraftsFilter from "@/components/Finances/Overdrafts/OverdraftsFilter.vue";
import {ScrollButton} from "wings-ui-components";
import {OverdraftItem} from "@/store/finance/types";
import {currentDay} from "@/utils/date-util";

@Component({
  components: {OverdraftsFilter, ScrollButton},
  methods: {currentDay},
})
export default class Overdrafts extends BaseItemsPage<OverdraftItem> {

  @Getter("overdrafts") overdraftsResponse!: OverdraftItem[];

  is_show_filter = false;
  currentSort = "partner";
  tableFields: string[] = this.tableFieldsDefault;

  get tableFieldsDefault(): string[] {
    return ["partner", "balance", "overdraft"];
  }

  getData(): OverdraftItem[] {
    return this.overdraftsResponse;
  }
}
